<re-captcha
  class="captcha"
  [id]="id"
  [class.invisible-captcha]="isInvisibleRecaptcha"
  [siteKey]="props.recaptchaToken"
  (resolved)="onResolve($event)"
  (error)="onRecaptchaError()"
  [size]="props.recaptchaType"
></re-captcha>
